import Humanize from 'humanize-plus';
import React from 'react';
import { Button, message, Spin } from 'antd';
import { EyeInvisibleOutlined } from '@ant-design/icons';

import './styles.css';
import QuoteStore from '../../stores/QuoteStore';
import { useHistory } from 'react-router-dom';

interface Props {
    loading?: boolean;
    value: number;
    completed: boolean;
    quote_id: number;
}

export const QuoteListPrice = ({ value, completed, loading = false, quote_id, ...otherProps }: Props) => {
    const history = useHistory();
    return (
        <>
            {completed ? (
                <Spin spinning={loading}>
                    <div className="flex flex-col md:flex-row">
                        <span className="text-xs md:text-sm mr-0 md:mr-10" {...otherProps}>
                            {`$ ${Humanize.formatNumber(value, 2)}`}
                        </span>
                    </div>
                </Spin>
            ) : (
                <Spin spinning={loading}>
                    <div className="cursor-pointer">
                        <span className="text-xs md:text-sm mr-0 md:mr-2" {...otherProps}>
                            Pending
                        </span>
                    </div>
                </Spin>
            )}
        </>
    );
};
